// services/location/LocationComposite.ts
import { Location } from './types'

export class LocationComposite {
  private locations: Location[] = []
  private currentLocation: Location | null = null

  removeDefaultLocations() {
    this.setLocations(
      this.locations.filter(
        (location: Location) =>
          !(location.default === 'koeln' || location.default === 'berlin'),
      ),
    )
  }

  setLocations(locations: Location[]): void {
    this.locations = locations
  }

  addLocation(location: Location): void {
    this.locations.unshift(location)
  }

  findLocationByUrl(url: string): Location | null {
    return this.locations.find((loc) => loc.url === url) || null
  }

  getTopLocations(count: number): Location[] {
    return Array.isArray(this.locations) &&
      typeof this.locations.toSorted === 'function'
      ? this.locations
          .toSorted((a, b) => b.lastVisit - a.lastVisit)
          .slice(0, count)
      : []
  }

  setCurrentLocation(location: Location | null): void {
    this.currentLocation = location
  }

  getCurrentLocation(): Location | null {
    return this.currentLocation
  }

  getLocations(): Location[] {
    return this.locations
  }
}
